const LS_MARATHON_SESSIONS_KEY = 'marathon-sessions';

const ls = {
  get(name) {
    return localStorage.getItem(name);
  },
  set(name, value) {
    localStorage.setItem(name, value);
  },
  remove(name) {
    localStorage.removeItem(name);
  },

  getMarathonSessions() {
    try {
      const raw = localStorage.getItem(LS_MARATHON_SESSIONS_KEY);
      if (!raw) return [];
      const arr = JSON.parse(raw);
      if (!Array.isArray(arr)) return [];
      return arr.sort((a, b) => new Date(b.last_activity) - new Date(a.last_activity));
    } catch (e) {
      return [];
    }
  },

  upsertMarathonSession(entry) {
    const sessions = this.getMarathonSessions();
    const idx = sessions.findIndex(s => s.uuid === entry.uuid);
    const updated = { ...entry, last_activity: new Date().toISOString() };
    if (idx >= 0) {
      sessions[idx] = { ...sessions[idx], ...updated };
    } else {
      sessions.unshift(updated);
    }
    localStorage.setItem(LS_MARATHON_SESSIONS_KEY, JSON.stringify(sessions));
  },

  removeMarathonSession(uuid) {
    const sessions = this.getMarathonSessions().filter(s => s.uuid !== uuid);
    localStorage.setItem(LS_MARATHON_SESSIONS_KEY, JSON.stringify(sessions));
    if (localStorage.getItem('marathon-session-uuid') === uuid) {
      localStorage.removeItem('marathon-session-uuid');
    }
  },
  updateAppSettings(newValue) {
    localStorage.setItem('pdd-settings', JSON.stringify(newValue));
  },
  initAppSettings() {
    if (!localStorage.getItem('pdd-settings')) {
      localStorage.setItem('pdd-settings', JSON.stringify({
        ticketResults: [],
        themeResults: [],
        examResults: [],
        constructorResults: [],
      }));
    }
  },
};

export default ls;
